export enum EInputsPromoLandingRoute {
  syngenta = '/promo/syngenta',
  vezdehod = '/promo/toplivnaya-karta',
}
